import "./CompletedCollectionTransacitonsDataGridWithColumnToggledStyle.css";

import { Box, Typography, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { EnhancedButtonPrimeReact } from "../../../../EnhancedButtonPrimeReact";
import {
	EnhancedButtonPrimeReactSeverity,
} from "../../../../../common/Common";
import { RequestParams } from "@websential/cosmic-v20";

export interface IDataTable {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	showSettingColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	cardHeaderTitle?: string;
	cardHeaderSubTitle?: string;
	disabledHeaderTooltip?: boolean;
	viewIcon?: boolean;
	whiteSpace?: string;
	exportButton?: boolean;
	exportButtonLabel?: string;
	exportButtonInFileList?: boolean;
	// onExportButtonClick?: (event: string, params: any) => void;
	onExportButtonClick?: (event: string) => void;
	onExportButtonInFileListClick?: (event: string, params: any) => void;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	provinceOfEmployementDDL?: any;
	countryList?: any;
	provinceOrStateDDL?: any;
	onImportButtonClickedHandler?: () => void;
	onImportExcelButtonClickedHandler?: () => void;
	selectedRows: (value: any) => void




	selectedSubRows: (value: any) => void;
	showRowExpandedView?: boolean;
}



export const CompletedCollectionTransacitonsDataGrid: React.FC<IDataTable> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	showSettingColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	onExportButtonClick,
	selectedRows,



	selectedSubRows,
	showRowExpandedView
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	// const [employeeListItems, setEmployeeListItems] = useState<any>(undefined);
	const [selectedItems, setSelectedItems] = useState<any>([]);

	// useEffect(() => {
	// 	if (rows && JSON.stringify(rows) !== JSON.stringify(employeeListItems)) {
	// 		setEmployeeListItems(rows);
	// 	}
	// }, [rows]);
	const [completedCollection, setCompletedCollection] = useState<any>(
		rows && rows
	);

	// useEffect(() => {
	// 	completedCollectionUpdatedData(completedCollection);
	// }, [completedCollection]);

	// useEffect(() => {
	// 	if (rows) {
	// 		setCompletedCollection(rows);
	// 	}
	// }, [rows]);

	const safeStringify = (obj: any) => {
		const seen = new WeakSet();
		return JSON.stringify(obj, (key, value) => {
			if (typeof value === "object" && value !== null) {
				if (seen.has(value)) return "[Circular]";
				seen.add(value);
			}
			return value;
		});
	};

	useEffect(() => {
		if (rows && safeStringify(rows) !== safeStringify(completedCollection)) {
			setCompletedCollection(rows);
		}
	}, [rows, completedCollection]);


	/* *************************************************************Expanded Rows **************************************************************** */

	const prevExpandedSelectionRef = useRef<any[]>([]);
	const [selectedSubItems, setSelectedSubItems] = useState<any>([]);
	const [inProcessSubPayment, setInProcessSubPayment] = useState<any>(undefined);


	// arrange column widths
	const mainTableRef = useRef<any>(null);
	const [columnWidths, setColumnWidths] = useState<Record<string, number>>({});

	useEffect(() => {
		if (!mainTableRef.current || !columns) return;

		const table = mainTableRef.current.getElement();
		const headers = table.querySelectorAll(".p-datatable-thead > tr > th");

		const widthMap: Record<string, number> = {};

		// skip non-data columns (checkbox, index, expander etc.)
		const dataHeaders = Array.from(headers).slice(headers.length - columns.length);

		dataHeaders.forEach((th: any, i: number) => {
			const field = columns[i]?.field;
			if (field) {
				widthMap[field] = th.offsetWidth;
			}
		});

		setColumnWidths(widthMap);
	}, [rows, columns]);


	// ///////////////////////////// Expanded Rows /////////////////////////////////////////////
	const [expandedRows, setExpandedRows] = useState(rows);
	const collapseAll = () => {
		setExpandedRows(null);
	};
	const expandAll = () => {
		let _expandedRows: Record<string, boolean> = {};

		rows?.forEach((p: any) => {
			if (p.orders && p.orders.length > 0) {
				_expandedRows[p.id] = true;
			}
		});

		setExpandedRows(_expandedRows);
	};
	const syncChildrenFromParents = (
		prevChildren: any[],
		parents: any[]
	) => {
		const parentIds = new Set(parents.map(p => p.id));


		const kept = prevChildren.filter(c =>
			parentIds.has(c.parentId)
		);
		const NotKept = prevChildren.filter(
			c => !parentIds.has(c.parentId)
		);
		const updatedNotKept = rows && rows.reduce((acc: any, parent: any) => {
			const parentOrderIds = parent.orders?.map((o: any) => o.id);

			const allOrdersPresent = parentOrderIds?.every((orderId: any) =>
				acc.some((nk: any) => nk.id === orderId)
			);

			if (allOrdersPresent) {
				// remove all matching children
				return acc.filter((nk: any) => !parentOrderIds?.includes(nk.id));
			}

			return acc;
		}, NotKept);


		const added = parents.flatMap(p => p.orders ?? []);


		return Array.from(
			new Map([...updatedNotKept, ...added].map(c => [c.id, c])).values()
		);
	};

	const updateParentFromChildren = (
		prevData: any[],
		selectedRows: any[],
		clickedRow: any,
		completedCollection: any
	) => {
		if (clickedRow && selectedRows.length !== 0 && rows && completedCollection) {
			const parentOfClickedRow = rows && rows?.find((row: any) =>
				row.orders?.includes(clickedRow)
			);

			const allOrdersAvailInSelectedSubItems = parentOfClickedRow && parentOfClickedRow.orders && parentOfClickedRow.orders?.every((item: any) => selectedRows.includes(item))

			if (allOrdersAvailInSelectedSubItems) {
				const updatedSelectedItems = selectedItems?.includes(parentOfClickedRow) ? selectedItems : [...selectedItems, parentOfClickedRow];

				return updatedSelectedItems
			} else {
				const updatedSelectedItems = selectedItems?.filter((i: any) => i !== parentOfClickedRow)

				return updatedSelectedItems
			}
		} else {
			return []
		}
	};

	const onSelectionModelForExpandedRowsChange = useCallback(
		(items: any) => {
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {

				const selectedRow = rows && rows.filter((x: any) => x.id === selectedItem?.parentId)

				return rows && selectedRow.orders?.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedSubItems(items.value);
			selectedSubRows(items.value);
			const current = items.value;
			const prev = prevExpandedSelectionRef.current;

			const added = current.find(
				(c: any) => !prev.some((p: any) => p.id === c.id)
			);

			const removed = prev.find(
				(p: any) => !current.some((c: any) => c.id === p.id)
			);
			prevExpandedSelectionRef.current = current;
			if (!current) {
				prevExpandedSelectionRef.current = current;
				return;
			}
			let clickedRowTutiFruti;
			if (items.value.length > selectedSubItems.length) {
				// Row Selected
				clickedRowTutiFruti = items.value.find(
					(row: any) =>
						!selectedSubItems.some((r: any) => r.id === row.id)
				);
			} else {
				// Row Unselected
				clickedRowTutiFruti = selectedSubItems.find(
					(row: any) =>
						!items.value.some((r: any) => r.id === row.id)
				);
			}
			setSelectedItems((prev: any) =>
				updateParentFromChildren(prev, items.value, clickedRowTutiFruti, completedCollection)
			);
			selectedRows((prev: any) =>
				updateParentFromChildren(prev, items.value, clickedRowTutiFruti, completedCollection)
			);
		},
		[rows, selectedRowsValues, selectedSubItems, completedCollection]
	);

	let updatedHeaderColumnsForSubTable = columns && columns.map((x: any) => ({
		...x,
		field: x.field === "clientName" ? "employeeName" : x.field,
	}));

	const rowExpansionTemplate = (data: any) => {
		// const hasParent = selectedItems.some((item: any) => item.id === data.id);
		const parentId = data.id
		setInProcessSubPayment(data.orders);
		return (
			<div className="p-3">
				<DataTable value={data.orders}
					// className={hasParent ? "p-disabled ExpandedDataGrid" : "ExpandedDataGrid"}
					className={"ExpandedDataGrid"}
					selection={selectedSubItems}
					onSelectionChange={onSelectionModelForExpandedRowsChange}
					selectionMode={"checkbox"}
					key={selectedSubItems}

					dataKey="id"
					scrollable
				>
					<Column
						body={" "}
						style={{
							width: "2.9rem",
							minWidth: "47px",
							left: 0,
							position: "sticky",
							zIndex: 2,
							textAlign: "center",
							background: "white",
							color: "white",
							userSelect: "none"
						}}
					/>
					{rows && rows.length ? (
						<Column
							selectionMode="multiple"
							hidden={!showChecboxColumn}
							frozen
							resizeable={false}
							style={{ width: "36px", textAlign: "center", left: '2.9rem' }}
							field="selection"
							alignFrozen="left"
							columnKey="selection"
							className="selectionSubHeader"
						></Column>
					) : undefined}
					{rows && rows.length ? (
						<Column
							header="#"
							className="indexSubColumn"
							headerClassName="indexColumn"
							headerStyle={{ width: "26px" }}
							frozen
							hidden={!showIndexColumn}
							body={(data, options) => options.rowIndex + 1}
						></Column>
					) : undefined}
					{columns &&
						updatedHeaderColumnsForSubTable.map((x: any, index: any) => (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								align={x.align}
								style={{
									minWidth: x.minWidth,
									fontSize: "0.875rem",
								}}
							/>
						))}
				</DataTable>
			</div>
		);
	};

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);

	const editColumn = (params: any) => {
		return (
			<>
				<EnhancedButtonPrimeReact
					icon={"pi pi-pencil"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/>
			</>
		);
	};

	const deleteRowColumn = (params: any) => {
		return (
			<EnhancedButtonPrimeReact
				icon="pi pi-times"
				onClickHandler={() => onRowDeleteClicked && onRowDeleteClicked(params)}
				severity={EnhancedButtonPrimeReactSeverity.Danger}
				className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
				rounded
			/>
		);
	};

	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{/* {showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{
							display: "flex",
							marginLeft: "10px",
							height: "37px",
							maxWidth: "250px",
						}}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding: "10px 22px 10px 10px",

								// borderRadius: "0px 2px 2px 0px",
								// fontSize: ".875rem",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								borderRadius: "0px 2px 2px 0px",
								fontSize: ".875rem",
							}}
						>
							Search
						</Button>
					</span>
				)} */}
				<span></span>

				{/* {rows && rows.length > 0 ? (
					<EnhancedButtonPrimeReact
						// icon="pi pi-trash"
						label="Add Error Message"
						raised
						onClickHandler={onAddErrorMessageButtonClickedHandler}
						style={{ marginRight: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
				) : (
					<></>
				)} */}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.clientName.props.children
						.toLowerCase()
						.indexOf(itemSearsch.toLowerCase()) > -1
			)
		);
	}

	const onPage = (event: any) => {
		setLoading(true);

		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}

			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);

	useEffect(() => {
		if (onRequestParamsChange) {
			if (isInitialRequest.current === true) {
				isInitialRequest.current = false;
			} else {
				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});
		}
	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);

			const updatedSelectedItems = items.value.filter((selectedItem: any) => {

				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			selectedRows(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);

			// 
			// setSelectedSubItems((prev: any[]) => [
			// 	...prev,
			// 	...syncSubItemsFromParents(updatedSelectedItems),
			// ]);
			setSelectedSubItems((prev: any) =>
				syncChildrenFromParents(prev, items.value)
			);
			selectedSubRows((prev: any) =>
				syncChildrenFromParents(prev, items.value)
			);

			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);
				}
			}
		},
		[rows, selectedRowsValues, selectedItems, selectedSubItems]
	);
	useEffect(() => {
		// Check for deleted items and remove them from selectedItems
		const updatedSelectedItems =
			selectedItems &&
			selectedItems.length > 0 &&
			selectedItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedItems &&
			updatedSelectedItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedItems);
			selectedRows(updatedSelectedItems);

			const updatedSelectedItemsIds = updatedSelectedItems.map(
				(item: any) => item.id
			);
			// Update selectedItemsIds
			setSelectedItemsIds(updatedSelectedItemsIds);
		}
		// const updatedSelectedSubItems = selectedSubItems.filter(
		// 	(item: any) => !selectedItemsIds.includes(item.parentId)
		// );
		// if (
		// 	updatedSelectedSubItems &&
		// 	updatedSelectedSubItems.length !== selectedSubItems.length
		// ) {
		// 	setSelectedSubItems(updatedSelectedSubItems)
		// 	selectedSubRows(updatedSelectedSubItems)
		// }

	}, [rows, selectedItems, selectedItemsIds, selectedSubItems]);

	const hasOrders = rows && rows?.some((x: any) => x.orders?.length > 0);



	const getRowClassName = (rowData: any) => {
		return 'bold-row';
	};



	return (
		<>
			<DataTable
				value={
					rows &&
					completedCollection &&
					completedCollection
				}
				responsiveLayout="scroll"
				lazy
				dataKey="id"
				paginator
				first={requestParams.first}
				rows={requestParams.rows}
				totalRecords={totalRecords}
				onPage={onPage}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
				currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				key={selectedItems}
				editMode=""
				selectionMode={"checkbox"}
				showGridlines
				// resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// // reorderableColumns
				// onColReorder={onColReorder}
				loading={isLoading ? isLoading : loading}
				// header={headerSearch}
				footer={footer ? footer : undefined}
				emptyMessage={
					rows && rows.length === 0 ? "No Record Found." : "Loading..."
				}
				className="CompletedCollectionTransacitonsDataGridWithColumnToggled"
				// style={{
				// 	margin: `${tableMargin ? tableMargin : "16px 0 0.5rem 0"}`,
				// }}
				sortMode="single"
				onSort={onSort}
				rowClassName={getRowClassName}


				rowExpansionTemplate={showRowExpandedView ? rowExpansionTemplate : undefined}
				expandedRows={showRowExpandedView ? expandedRows : undefined} onRowToggle={
					showRowExpandedView ? (e) => setExpandedRows(e.data) : undefined}
			>
				{columns && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						alignFrozen="left"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}
				{rows && rows.length ? (
					<Column
						header="#"
						className="indexColumn"
						headerClassName="indexColumn"
						headerStyle={{ width: "24px" }}
						frozen
						hidden={!showIndexColumn}
						body={(data, options) => options.rowIndex + 1}
					></Column>
				) : undefined}

				{showRowExpandedView && rows && hasOrders && <Column expander={rows && rows.length > 0 ? true : false} style={{ width: "1rem" }}
					bodyClassName={(rowData) =>
						rowData.orders && rowData.orders.length > 0
							? '' // show icon
							: 'no-expander' // hide icon
					}
					frozen
					alignFrozen="left"
				/>}

				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									// sortable={x.sortable}
									// resizeable={x.resizable}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={x.disableReorder}
									exportable={x.disableExport}
									frozen={x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										maxWidth: x.maxWidth,
										fontSize: "0.875rem",
									}}
									headerStyle={{ whiteSpace: whiteSpace ? whiteSpace : "nowrap" }}
									footer={x.footer}
								// body={(rowData: any, row: any) =>
								// 	columnsBody(rowData, row, x)
								// }
								// headerClassName={x.field === "uploadDate" ? "actions-header" : x.field === "uploadTime" ? "actions-header" : ""}
								/>
							);
						})}
			</DataTable>
		</>
	);
};
